import { HEADERS } from "../ConsumeService";

export class ModulosService {

    static consultarPermisos(idPerfil) {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_URL_SERVICE_MODULOS_PERMISOS_GET, {
                method: "POST",
                headers: HEADERS,
                body: JSON.stringify({ PerfilId: idPerfil })
            }).then((res) => res.json()).then((data) => {
                resolve(data.SDTPerfilModulo);
            });
        });
    }

    static asignarPermisosModulo(request) {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_URL_SERVICE_MODULOS_PERMISOS_POST, {
                method: "POST",
                headers: HEADERS,
                body: JSON.stringify(request)
            }).then((res) => res.json()).then((data) => {
                resolve(data);
            });
        });
    }

    static actualizarPerfilModulo(request) {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_URL_SERVICE_MODULOS_PERMISOS_PUT, {
                method: "POST",
                headers: HEADERS,
                body: JSON.stringify(request)
            }).then((res) => res.json()).then((data) => {
                resolve(data);
            });
        });
    }

    static consultarModulos() {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_URL_SERVICE_MODULOS_GET_ALL, {
                method: "POST"
            }).then((res) => res.json()).then((data) => {
                resolve(data.SDTModulo);
            });
        });
    }

}